import { useEffect } from 'react';

/**
 * @param {number} duration
 * @param {() => void} cb
 * @param {any[]} deps
 */
export default function useInterval(duration, cb, deps) {
    console.assert(duration >= 0, 'useInterval:duration must be a positive number');
    console.assert(typeof cb === 'function', 'useInterval:cb must be a function');
    console.assert(Array.isArray(deps), 'useInterval:deps must be an array');

    useEffect(() => {
        const interval = setInterval(cb, duration);

        return () => clearInterval(interval);
    }, deps);
}